export default function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}


//////////////////
// WEBPACK FOOTER
// ../~/@babel/runtime/helpers/esm/nonIterableSpread.js
// module id = 1445
// module chunks = 121